// 1. React
import React from 'react';

// 2. Third-party
import { Tabs } from 'antd';

// 3. Components
import LayoutWrapper from '@iso/components/utility/layoutWrapper.js';
import PageHeader from '@iso/components/utility/pageHeader';
import IntlMessages from '@iso/components/utility/intlMessages';

// 4. Local components
import FormTemplatesTab from './FormTemplatesTab';
import FormCategoriesTab from './FormCategoriesTab';

const { TabPane } = Tabs;

// "Manage Library Of Forms" — tabbed shell. Default tab: Form Templates.
const ManageLibraryForms = () => (
  <LayoutWrapper>
    <PageHeader>
      <IntlMessages id="sidebar.manageLibraryForms" />
    </PageHeader>
    <Tabs defaultActiveKey="templates" style={{ width: '100%' }}>
      <TabPane tab={<IntlMessages id="adminPage.libraryForm.tabTemplates" />} key="templates">
        <FormTemplatesTab />
      </TabPane>
      <TabPane tab={<IntlMessages id="adminPage.libraryForm.tabCategories" />} key="categories">
        <FormCategoriesTab />
      </TabPane>
    </Tabs>
  </LayoutWrapper>
);

export default ManageLibraryForms;
